import { Formik, Field as FormikField, useField } from 'formik';
import React from 'react';
import { Form } from 'react-bootstrap';

import useChartSettings from '../../hooks/useChartSettings';

function ChartSettingsForm() {
  const [chartSettings, setChartSettings] = useChartSettings();

  // eslint-disable-next-line no-unused-vars
  const CheckBoxField = ({ _, ...props }) => {
    const [field] = useField(props);
    return <Form.Check {...field} {...props} />;
  };
  return (
    <div>
      <Formik
        enableReinitialize={true}
        initialValues={{ ...chartSettings }}
        onSubmit={(values, actions) => {
          actions.setSubmitting(false);
        }}
        validate={(values) => {
          setChartSettings({ ...values });
        }}
      >
        {(props) => (
          <form>
            <div className="px-2">
              <h4 className="font-medium mb-4 text-center">
                Isotopic distribution preferences
              </h4>
              <Form.Group>
                <span>FWHM</span>
                <FormikField
                  type="number"
                  step="any"
                  name="fwhm"
                  className="py-1 px-4 mx-2 rounded-lg outline-none focus:ring bg-white border border-black"
                />
              </Form.Group>
              <Form.Group>
                <CheckBoxField
                  style={{ display: 'inline-flex' }}
                  name="profile"
                  checked={props.values.profile}
                  onChange={props.handleChange}
                  type="checkbox"
                />
                <span> Profile</span>
              </Form.Group>
              <Form.Group>
                <CheckBoxField
                  style={{ display: 'inline-flex' }}
                  name="centroid"
                  checked={props.values.centroid}
                  onChange={props.handleChange}
                  type="checkbox"
                />
                <span> Centroid</span>
              </Form.Group>
              <Form.Group>
                <CheckBoxField
                  style={{ display: 'inline-flex' }}
                  name="peaks"
                  checked={props.values.peaks}
                  onChange={props.handleChange}
                  type="checkbox"
                />
                <span> Show best peaks</span>
              </Form.Group>
            </div>
          </form>
        )}
      </Formik>
    </div>
  );
}

export default ChartSettingsForm;
